    <header class="page-head">
      <div>
        <h1 class="page-title">My Contacts</h1>
        <p class="page-subtitle">Search, add, edit, and remove saved contacts in your Central Profile directory.</p>
      </div>
      <button class="btn btn-primary" type="button" (click)="openAddModal()">Add new contact</button>
    </header>

    <section class="panel">
      <div class="search-bar">
        <input type="search" [formControl]="searchControl" placeholder="Search existing contacts" />
      </div>

      <div class="contact-list" *ngIf="filteredContacts().length; else emptyState">
        <article class="contact-card" *ngFor="let contact of filteredContacts()">
          <div class="contact-top">
            <div>
              <h3 class="section-title section-title-tight">{{ contact.fullName }}</h3>
              <p class="contact-meta">{{ contact.phoneNumber }}</p>
              <p class="contact-meta">{{ contact.email }}</p>
              <p class="contact-meta">{{ contact.address }}</p>
            </div>
            <div class="contact-actions">
              <button class="btn btn-secondary" type="button" (click)="openEditModal(contact)">Edit</button>
              <button class="btn btn-danger" type="button" (click)="openDeleteModal(contact)">Delete</button>
            </div>
          </div>
        </article>
      </div>
    </section>

    <ng-template #emptyState>
      <div class="empty-state">
        <h3 class="section-title">No contacts match your search.</h3>
        <p class="label">Clear the search or add a new contact to get started.</p>
      </div>
    </ng-template>

    <div class="modal-backdrop" *ngIf="activeModal() === 'form'">
      <div class="modal-card">
        <h2 class="section-title">{{ editingContact() ? 'Edit contact' : 'Add new contact' }}</h2>
        <form class="form-stack" [formGroup]="contactForm" (ngSubmit)="saveContact()">
          <div class="input-group">
            <label for="fullName">Name and surname</label>
            <input id="fullName" formControlName="fullName" />
          </div>
          <div class="input-group">
            <label for="phoneNumber">Phone number</label>
            <input id="phoneNumber" formControlName="phoneNumber" />
          </div>
          <div class="input-group">
            <label for="email">Email</label>
            <input id="email" type="email" formControlName="email" />
          </div>
          <div class="input-group">
            <label for="address">Address</label>
            <textarea id="address" formControlName="address"></textarea>
          </div>
          <div class="btn-row">
            <button class="btn btn-secondary" type="button" (click)="closeModal()">Discard</button>
            <button class="btn btn-primary" type="submit">{{ editingContact() ? 'Update' : 'Save' }}</button>
          </div>
        </form>
      </div>
    </div>

    <div class="modal-backdrop" *ngIf="activeModal() === 'delete'">
      <div class="modal-card">
        <h2 class="section-title">Delete contact</h2>
        <p class="danger-copy">If you delete this contact it will not be reversable.</p>
        <p class="label">{{ editingContact()?.fullName }}</p>
        <div class="btn-row btn-row-spaced-top">
          <button class="btn btn-secondary" type="button" (click)="closeModal()">Cancel</button>
          <button class="btn btn-danger" type="button" (click)="deleteContact()">Delete</button>
        </div>
      </div>
    </div>
